import { RouteRecordRaw } from 'vue-router';
import { FormBuilderPage } from '@/features/FormBuilder';

export const routeName = 'EditarModelo';

export const route: RouteRecordRaw = {
  path: '/edicao-modelos/:id',
  name: routeName,
  component: FormBuilderPage,
  meta: {
    requiresAuth: true,
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
